module.exports = __webpack_public_path__ + "img/Irving-Golf-Club.e85f423b.png";